import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarencecabserviceinmumbai() {



    const cardData = {





keyword: "Kia Carens Cab Service in Mumbai",

headingDescription: "Shreesha Tours & Travels provides premium Kia Carens Cab Service in Mumbai for airport transfers, local travel, corporate transportation, family vacations, outstation trips, business meetings, sightseeing tours, destination weddings, railway station transfers, and long-distance journeys across India. The Kia Carens is a stylish and spacious 6+1/7-seater MPV designed to offer exceptional comfort, modern interiors, advanced safety features, ample luggage space, and a smooth driving experience for families, corporate travelers, and small groups. Our chauffeur-driven Kia Carens rental service includes experienced drivers, well-maintained vehicles, doorstep pickup, transparent pricing, flexible booking options, and 24/7 customer support. Whether you need a one-way cab, round-trip taxi, multi-day tour, or customized outstation travel from Mumbai, Shreesha Tours & Travels ensures a safe, luxurious, and hassle-free journey. The Kia Carens is an excellent choice for travelers seeking premium comfort with economical pricing, making every trip enjoyable and relaxing." ,

topPlaces: [
  {
    title: "Mumbai to Saputara",
    description: "Saputara is Gujarat's only hill station, known for Saputara Lake, Sunset Point, Artist Village, ropeway rides, and cool weather. Kia Carens is ideal for comfortable family holidays and group weekend trips."
  },
  {
    title: "Mumbai to Ratnagiri",
    description: "Ratnagiri is famous for Ganpatipule Beach, Ratnadurg Fort, Thiba Palace, Alphonso mango orchards, and the beautiful Konkan coastline. It is a perfect destination for scenic road trips."
  },
  {
    title: "Mumbai to Ganpatipule",
    description: "Ganpatipule is renowned for its ancient Ganpati Temple, white sandy beaches, and peaceful surroundings. Families and pilgrims prefer Kia Carens for a relaxing coastal journey."
  },
  {
    title: "Mumbai to Karad",
    description: "Karad is a prominent town in western Maharashtra known for the Krishna-Koyna Sangam, educational institutions, and nearby hill destinations. It is a popular stop for business and family travel."
  },
  {
    title: "Mumbai to Solapur",
    description: "Solapur is famous for Siddheshwar Temple, textile industries, historical attractions, and its proximity to Tuljapur and Akkalkot. Kia Carens offers a comfortable ride for long-distance travel."
  },
  {
    title: "Mumbai to Hubli",
    description: "Hubli is an important commercial city in Karnataka known for business centers, temples, shopping markets, and easy connectivity to North Karnataka. It is frequently visited for business and leisure trips."
  },
  {
    title: "Mumbai to Dharwad",
    description: "Dharwad is known for its educational institutions, cultural heritage, peaceful environment, and nearby tourist attractions. It is an excellent destination for family travel and educational visits."
  },
  {
    title: "Mumbai to Belgaum",
    description: "Belgaum is famous for Belgaum Fort, Gokak Falls, Kapileshwar Temple, and pleasant weather. It is a preferred destination for weekend holidays, business visits, and family vacations."
  },
  {
    title: "Mumbai to Chikmagalur",
    description: "Chikmagalur is a picturesque hill station known for coffee plantations, Mullayanagiri Peak, waterfalls, and trekking trails. Kia Carens is an excellent vehicle for long-distance hill station tours."
  },
  {
    title: "Mumbai to Mysore",
    description: "Mysore is renowned for Mysore Palace, Chamundi Hills, Brindavan Gardens, St. Philomena's Church, and rich cultural heritage. It is a perfect destination for family vacations and heritage tours."
  }
],



"services": [
  {
    "name": "Kia Carens Cab Service in Mumbai",
    "description": "Book Kia Carens Cab Service in Mumbai for comfortable, spacious, and chauffeur-driven travel with professional drivers and well-maintained AC vehicles. The Kia Carens is ideal for airport transfers, family vacations, corporate travel, sightseeing tours, weddings, business meetings, and outstation journeys. Enjoy premium seating, generous luggage space, and flexible one way or round trip booking options for a smooth travel experience."
  },
  {
    "name": "Kia Carens Rental Mumbai",
    "description": "Choose Kia Carens Rental Mumbai for reliable transportation with stylish interiors, comfortable seating, and experienced chauffeurs. Our rental service is perfect for family outings, corporate events, airport transfers, holiday trips, hotel pickups, and long-distance travel across Maharashtra and India."
  },
  {
    "name": "Kia Carens Taxi Mumbai",
    "description": "Hire Kia Carens Taxi Mumbai for safe and affordable travel with spacious AC vehicles, courteous drivers, and transparent pricing. Suitable for local city rides, business travel, family functions, sightseeing, airport pickup and drop, and outstation journeys."
  },
  {
    "name": "Kia Carens on Rent Mumbai",
    "description": "Book Kia Carens on Rent Mumbai for premium chauffeur-driven transportation with comfortable seating, modern interiors, and flexible rental packages. Enjoy convenient travel for personal trips, corporate meetings, weddings, family vacations, and weekend getaways."
  },
  {
    "name": "Kia Carens Cab Booking Mumbai",
    "description": "Complete Kia Carens Cab Booking Mumbai online with instant confirmation, affordable pricing, and convenient pickup services. Reserve your preferred Kia Carens for airport transfers, local travel, business visits, sightseeing tours, family functions, and comfortable outstation travel."
  },
  {
    "name": "Kia Carens Hire Mumbai",
    "description": "Choose Kia Carens Hire Mumbai for dependable chauffeur-driven travel with experienced drivers, spacious interiors, and premium comfort. Ideal for business executives, family travel, religious tours, weddings, airport transfers, and interstate road trips."
  },
  {
    "name": "Kia Carens with Driver Mumbai",
    "description": "Reserve Kia Carens with Driver Mumbai for stress-free travel with professional chauffeurs, clean vehicles, and flexible travel schedules. Perfect for corporate events, hotel transfers, family holidays, sightseeing tours, airport transportation, and outstation journeys."
  },
  {
    "name": "Kia Carens Outstation Cab Mumbai",
    "description": "Book Kia Carens Outstation Cab Mumbai for comfortable one way and round trip travel across Maharashtra, Goa, Gujarat, Karnataka, and other destinations. Enjoy spacious seating, reliable drivers, transparent fares, and a smooth travel experience for family and corporate trips."
  },
  {
    "name": "Kia Carens Airport Taxi Mumbai",
    "description": "Choose Kia Carens Airport Taxi Mumbai for timely airport pickup and drop with flight tracking, luggage assistance, and professional chauffeurs. Travel comfortably to and from Mumbai Airport with spacious vehicles suitable for families, tourists, and business travelers."
  },
  {
    "name": "Kia Carens Luxury Cab Mumbai",
    "description": "Hire Kia Carens Luxury Cab Mumbai for premium travel with elegant interiors, comfortable seating, modern features, and experienced chauffeurs. Ideal for VIP transportation, weddings, executive travel, luxury sightseeing, and premium outstation journeys."
  },
  {
    "name": "Kia Carens Family Cab Mumbai",
    "description": "Book Kia Carens Family Cab Mumbai for safe and enjoyable family travel with spacious seating, ample luggage capacity, and professional drivers. Perfect for vacations, family gatherings, temple visits, airport transfers, weekend holidays, and long-distance road trips."
  },
  {
    "name": "Kia Carens Corporate Cab Mumbai",
    "description": "Choose Kia Carens Corporate Cab Mumbai for executive transportation, employee travel, client meetings, airport transfers, conferences, and business events. Our chauffeur-driven Kia Carens provides punctual, comfortable, and professional corporate travel services."
  },
  {
    "name": "Kia Carens One Way Taxi Mumbai",
    "description": "Reserve Kia Carens One Way Taxi Mumbai for affordable intercity travel without return fare charges. Enjoy fixed pricing, comfortable AC vehicles, professional chauffeurs, and convenient pickup services for airport transfers, business travel, and outstation journeys."
  },
  {
    "name": "Best Kia Carens Rental Mumbai",
    "description": "Book the Best Kia Carens Rental Mumbai for premium chauffeur-driven transportation with clean AC vehicles, courteous drivers, competitive pricing, and excellent customer support. Whether you require airport transfers, corporate travel, family vacations, wedding transportation, sightseeing tours, or outstation journeys, our Kia Carens rental service delivers a safe, luxurious, and comfortable travel experience every time."
  }
],
"tableData": [
  ["Kia Carens Cab Service in Mumbai", "Kia Carens Rental Mumbai"],
  ["Kia Carens Taxi Mumbai", "Kia Carens on Rent Mumbai"],
  ["Kia Carens Cab Booking Mumbai", "Kia Carens Hire Mumbai"],
  ["Kia Carens with Driver Mumbai", "Kia Carens Outstation Cab Mumbai"],
  ["Kia Carens Airport Taxi Mumbai", "Kia Carens Luxury Cab Mumbai"],
  ["Kia Carens Family Cab Mumbai", "Kia Carens Corporate Cab Mumbai"],
  ["Kia Carens One Way Taxi Mumbai", "Best Kia Carens Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Kia Carens Cab Service in Mumbai",
    WhyChoosedescription: "Upgrade your travel experience with Shreesha Travels by booking a Kia Carens cab in Mumbai. This premium MPV is ideal for airport transfers, business travel, family holidays, sightseeing, weekend getaways, and outstation journeys, offering exceptional comfort and modern features."
  },
  {
    WhyChooseheading: "Spacious MPV Designed for Comfortable Travel",
    WhyChoosedescription: "The Kia Carens offers spacious seating for up to six passengers, generous luggage space, modern interiors, rear AC vents, and a smooth driving experience, making it an excellent choice for both city and highway travel."
  },
  {
    WhyChooseheading: "Excellent Choice for Airport & Intercity Travel",
    WhyChoosedescription: "Reserve a Kia Carens for Mumbai Airport transfers or travel to Pune, Lonavala, Mahabaleshwar, Goa, Nashik, Shirdi, Surat, Ahmedabad, Indore, Bengaluru, Jaipur, and many more destinations with complete travel flexibility." 
  },
  {
    WhyChooseheading: "Preferred by Families, Corporate Teams & Tourists",
    WhyChoosedescription: "The Kia Carens is suitable for family vacations, executive transportation, client visits, destination weddings, pilgrimage tours, educational trips, hotel transfers, and holiday travel."
  },
  {
    WhyChooseheading: "Flexible Booking Options for Every Journey",
    WhyChoosedescription: "Choose one-way taxi services, round-trip bookings, airport transfers, full-day rentals, multi-day tours, or customized travel packages according to your itinerary and schedule."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Safe Road Trips",
    WhyChoosedescription: "Our professional drivers are well-versed in Mumbai city roads, expressways, and major intercity routes, ensuring a safe, punctual, and enjoyable journey throughout your trip."
  },
  {
    WhyChooseheading: "Modern, Sanitized & Well-Maintained Kia Carens",
    WhyChoosedescription: "Every Kia Carens is regularly serviced, cleaned, and inspected before every trip to provide passengers with a premium, comfortable, and dependable travel experience."
  },
  {
    WhyChooseheading: "Book Your Kia Carens with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, prompt booking assistance, and reliable chauffeur-driven transportation whenever you need a Kia Carens Cab Service in Mumbai."
  }
]

};

const faqData = [
  {
    question: "Why should I choose a Kia Carens cab in Mumbai?",
    answer: "The Kia Carens combines premium comfort, spacious seating, modern interiors, and excellent luggage capacity, making it ideal for family travel, business trips, and airport transfers."
  },
  {
    question: "How many passengers can travel in a Kia Carens?",
    answer: "The Kia Carens comfortably accommodates up to 6 passengers along with luggage, depending on the seating configuration." // supported by common rental offerings :contentReference[oaicite:1]{index=1}
  },
  {
    question: "Is the Kia Carens suitable for long-distance travel?",
    answer: "Yes, its comfortable cabin, smooth suspension, and spacious seating make it an excellent option for outstation road trips and extended journeys."
  },
  {
    question: "Can I book a Kia Carens for Mumbai Airport transfers?",
    answer: "Yes, chauffeur-driven Kia Carens cabs are available for airport pickups and drops at both domestic and international terminals."
  },
  {
    question: "Do you provide Kia Carens cabs for corporate travel?",
    answer: "Yes, the Kia Carens is widely preferred for executive travel, client meetings, conferences, office transportation, and VIP guest transfers."
  },
  {
    question: "Can I hire a Kia Carens for weddings and family functions?",
    answer: "Yes, the vehicle is an excellent choice for wedding transportation, family events, destination weddings, and guest transfers."
  },
  {
    question: "Are one-way and round-trip bookings available?",
    answer: "Yes, you can book the Kia Carens for one-way journeys, round trips, full-day rentals, and customized multi-day travel plans."
  },
  {
    question: "How is the Kia Carens cab fare calculated?",
    answer: "The fare depends on the travel distance, trip duration, destination, selected package, and any additional travel requirements."
  },
  {
    question: "Is advance booking recommended?",
    answer: "Yes, advance reservations help ensure vehicle availability, especially during weekends, holidays, and peak travel seasons."
  },
  {
    question: "How can I book a Kia Carens Cab Service in Mumbai with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and itinerary to receive a personalized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Trivedi",
    feedback: "The Kia Carens offered outstanding comfort throughout the journey. The spacious cabin, smooth drive, and courteous chauffeur made travelling with our group both relaxing and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Bhandari",
    feedback: "From the moment the vehicle arrived until the trip concluded, everything was managed professionally. The premium interiors and comfortable seating made the entire travel experience memorable.",
    rating: 5
  }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens Cab Service in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/kia-carens-cab-service-in-mumbai.webp",
  "description":
    "Book Kia Carens Cab Service in Mumbai with Shreesha Tours & Travels for premium, comfortable, and spacious chauffeur-driven cab services. We provide Kia Carens rentals available 24x7 for airport transfers, corporate travel, family trips, business meetings, sightseeing tours, and outstation journeys with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/kia-carens-cab-service-in-mumbai"
  }
};







    return (
        <div>

<Helmet>
  <title>Kia Carens Cab Service in Mumbai | Premium 7 Seater Cab | +91 8355835813</title>

  <meta
    name="description"
    content="Book Kia Carens Cab Service in Mumbai with Shreesha Travels for premium 7 seater cab rental services. Hire Kia Carens with driver for airport transfers, corporate travel, family trips, sightseeing, and outstation journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Kia Carens Cab Service in Mumbai, Kia Carens Rental Mumbai, Kia Carens Taxi Mumbai, Kia Carens on Rent Mumbai, Kia Carens Hire Mumbai, Kia Carens Cab Booking Mumbai, Kia Carens Airport Taxi Mumbai, Kia Carens Outstation Cab Mumbai, Kia Carens with Driver Mumbai, Premium Car Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarencecabserviceinmumbai;